import superMeta from '../_BASE/metaBaseNode.mjs'

export default {
    ...superMeta,
    classes: ['design', ...superMeta.classes],
    catProp: 'catNode',
    codeProp: '',
}
